import CloseIcon from '@mui/icons-material/Close';
import { Box, Tooltip } from '@mui/material';
import React, { useState } from 'react';

import CallForHelp from '../CallForHelp';
import DeclineOrCancelModal from '../DeclineOrCancelModal';

import { MarkAsCompleteProps } from './interface';

import './styles.scss';

import { Button } from '@components/ButtonV2';
import useGoogleTagManager from '@hooks/useGoogleTagManager';
import { EDeliveryType, EOrderSubstatus } from '@utils/enums';
import { assembleOrderDetailGTMEvent } from '@utils/GoogleTagManager';
import { GOOGLE_TAG_MANAGER_EVENT_MESSAGES } from '@utils/GoogleTagManager/interface';

export const MarkAsCompleteFooter = ({
  order,
  isUpdateLoading,
  completeDisabled,
  isCompleteLoading,
  updateButtonTooltip,
  updateButtonDisabled,
  updateButtonCallback,
  completeButtonCallback,
}: MarkAsCompleteProps) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { setGTMEvent } = useGoogleTagManager();
  const orderStatus = order?.current_status?.substatus;
  const deliveryType = order?.delivery?.type;
  const canSupplierCancel = orderStatus !== EOrderSubstatus.APPROVED_DELIVERED;

  const getButtonLabel = () => {
    if (
      deliveryType === EDeliveryType.SHIPMENT_DELIVERY &&
      orderStatus === EOrderSubstatus.APPROVED_AWAITING_DELIVERY
    )
      return 'ORDER SHIPPED';

    return 'ORDER PICKED UP';
  };

  const renderCancelModal = () => {
    if (!showCancelModal) return null;

    return (
      <DeclineOrCancelModal
        orderId={String(order?.id)}
        onClose={() => setShowCancelModal(false)}
        isOpen={showCancelModal}
        isCancel
      />
    );
  };

  const handleCancelRequestButtonClick = () => {
    setGTMEvent(
      assembleOrderDetailGTMEvent(
        GOOGLE_TAG_MANAGER_EVENT_MESSAGES.CLICKED_ON_CANCEL_REQUEST,
        {
          orderDetail: {
            status: order.current_status.status,
            subStatus: order.current_status.substatus,
            orderId: order.id,
          },
        },
      ),
    );
    setShowCancelModal(true);
  };

  const handleUpdateButtonClick = () => {
    setGTMEvent(
      assembleOrderDetailGTMEvent(
        GOOGLE_TAG_MANAGER_EVENT_MESSAGES.CLICKED_ON_UPDATE_BUTTON,
        {
          orderDetail: {
            orderId: order.id,
          },
        },
      ),
    );
    updateButtonCallback();
  };

  return (
    <div className='bl-mark-as-complete-container mt-6 w-full'>
      <div className='flex flex-row items-center justify-center gap-4'>
        <Tooltip
          title={updateButtonDisabled ? updateButtonTooltip : ''}
          placement='top'
        >
          <Box>
            <Button
              variant='contained'
              className='update-button'
              loading={isUpdateLoading}
              disabled={
                updateButtonDisabled || isUpdateLoading || isCompleteLoading
              }
              onClick={handleUpdateButtonClick}
            >
              Update
            </Button>
          </Box>
        </Tooltip>

        <Button
          variant='contained'
          color='success'
          className='picked-up-button'
          disabled={completeDisabled || isCompleteLoading || isUpdateLoading}
          loading={isCompleteLoading}
          onClick={completeButtonCallback}
        >
          {getButtonLabel()}
        </Button>
      </div>

      {canSupplierCancel && (
        <div className='mt-4 flex flex-row items-center justify-center'>
          <Button
            variant='outlined'
            color='error'
            startIcon={<CloseIcon />}
            onClick={handleCancelRequestButtonClick}
          >
            Cancel Request
          </Button>
        </div>
      )}
      <CallForHelp />
      {renderCancelModal()}
    </div>
  );
};
